module.exports = __webpack_public_path__ + "ca4c175fe89ce8626953a26711e6430b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CW.svg
// module id = DnG2
// module chunks = 0